var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert"},_vm._l((_vm.alerts),function(item){return _c('div',{key:item.id,staticClass:"alert-container"},[_c('div',{staticClass:"alert-content"},[_vm._v(_vm._s(item.content))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }